import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import ImageUploadModal from 'components/common/ImageUploadModal';
import { BACKGROUND_TYPE } from 'features/Genre/constans';
import { Genre } from 'features/Genre/models/Genre';
import { Formik } from 'formik';
import { useRef, useState } from 'react';
import { Alert, Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IMAGE_SIZES } from 'utils/constants';
import * as yup from 'yup';
import ModalPreView from '../../../components/ModalPreView';
import service from '../services';
interface AddModalInterface {
  show: boolean;
  handleCloseModalAdd?: (status: boolean) => void;
  dataTable?: Genre[];
  setDataTable?: (genres: Genre[]) => void;
}

function GenreFormAdd({ handleCloseModalAdd, dataTable, setDataTable }: AddModalInterface) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const [previewImage, setPreviewImg] = useState('');
  const [previewBg, setPreviewBg] = useState('');

  const schema = yup.object().shape({
    name: yup.string().required(t('Genre.Validator.name')),
  });
  const initialValues: Genre = {
    id: 0,
    name: '',
    img: '',
    background_color: '#000000',
    background_img: '',
    display_name: '',
    display_name_ja: '',
    display_name_en: '',
    display_name_vi: '',
    display_name_ko: '',
    display_name_zh_hant: '',
    display_name_zh_hans: '',
    note: '',
    delete_flg: false,
    background_type: 0,
  };

  const [genrePreview, setGenrePreview] = useState<Genre>(initialValues);

  function handleCloseModelSucess() {
    handleCloseModalAdd && handleCloseModalAdd(true);
  }

  async function handleSubmitForm(values: Genre) {
    await service
      .addGenre(values)
      .then((res) => {
        if (dataTable) {
          let data = dataTable;
          data.push(res.data);
          setDataTable && setDataTable(data);
        }
      })
      .then(() => {
        showGlobalModal?.(() => (
          <AlertModal
            onClose={handleCloseModelSucess}
            title={t('Genre.Validator.success')}
            message={t('Genre.Validator.add_success')}
          ></AlertModal>
        ));
      })
      .catch((error) => {
        showGlobalModal(() => (
          <AlertModal
            title={t('Genre.Validator.error')}
            message={JSON.stringify(error.response.data.data)}
          ></AlertModal>
        ));
      });
  }
  const [showModalPreView, setShowModalPreView] = useState(false);
  function handleShowModalPreview() {
    setShowModalPreView(true);
  }

  function handleCloseModalPreview() {
    setShowModalPreView(false);
  }
  const refRadioBtnBackgrounImg = useRef<HTMLInputElement>(null);
  const refRadioBtnBackgrounColor = useRef<HTMLInputElement>(null);

  return (
    <Formik validationSchema={schema} onSubmit={handleSubmitForm} initialValues={initialValues}>
      {({ handleSubmit, handleChange, errors, values, setFieldValue }) => {
        return (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Col sm={2} md={2} lg={2} xl={2} style={{ display: 'none' }}>
                <Button onClick={handleShowModalPreview} className="btn--orange">
                  {t('Genre.Button.preview')}
                </Button>
                <ModalPreView
                  show={showModalPreView}
                  handleCloseModalPreview={handleCloseModalPreview}
                  genre={values}
                />
              </Col>
              <Col sm={8} md={8} lg={8} xl={8} style={{ display: 'none' }}>
                <p>
                  ※モバイルオーダーは、 <br /> 　日本語以外の言語を選択し、1その言語が未設定の場合、
                  <br /> 　英語が表示されます。
                </p>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                <Button
                  className="pull-right"
                  onClick={() => {
                    handleSubmit();
                  }}
                  variant="success"
                >
                  {t('Genre.Button.keep')}
                </Button>
              </Col>
            </Form.Group>
            <Table bordered className="table-genre">
              <tbody>
                <tr>
                  <th style={{ backgroundColor: '#36489a', width: '50%' }} colSpan={3}>
                    {t('Genre.Form.genre_name')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="name"
                      onChange={handleChange}
                      placeholder={t('Genre.Form.genre_name')}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('Genre.Form.image')}
                  </th>
                  <td className="genre">
                    <Form.Group as={Row} className="mb-3">
                      <Col>
                        <input
                          type="button"
                          style={{ textAlign: 'right' }}
                          onClick={() => {
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={previewImage && previewImage.length > 0 ? previewImage : ''}
                                  minWidth={IMAGE_SIZES.genre_order_background_img.minWidth}
                                  minHeight={IMAGE_SIZES.genre_order_background_img.minHeight}
                                  maxWidth={IMAGE_SIZES.genre_order_background_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.genre_order_background_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.genre_order_background_img.maxFileSize}
                                  onReflect={(filename: string, imagepath: string) => {
                                    setFieldValue('img', filename);
                                    setPreviewImg(process.env.REACT_APP_IMAGE_URL + filename);
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                          id="actual-img"
                          hidden
                          name="img"
                        />
                        <label htmlFor="actual-img" style={{ marginRight: 10 }}>
                          {t('Genre.Form.image')}
                        </label>
                        {previewImage && <img src={previewImage} alt="img" width={45} height={45} />}
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a', width: '13%' }} rowSpan={3}>
                    {t('Genre.Form.background')}
                  </th>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a', width: '13%' }} colSpan={2}>
                    {t('Genre.Form.color')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          name="background_type"
                          ref={refRadioBtnBackgrounColor}
                          onChange={(event) => {
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_type: BACKGROUND_TYPE.COLOR,
                            });
                          }}
                          value={0}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        <Alert
                          key="danger"
                          variant="light"
                          style={{
                            textAlign: 'center',
                            backgroundColor: values.background_color,
                            height: 45,
                            color: '#000000',
                          }}
                        >
                          {values.name}
                        </Alert>
                      </Col>
                      <Col style={{ textAlign: 'right' }}>
                        <Form.Control
                          id="actual-color"
                          type="color"
                          defaultValue="#000000"
                          name="background_color"
                          onChange={(event) => {
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_color: event.target.value,
                            });
                            if (refRadioBtnBackgrounColor.current) {
                              console.log(refRadioBtnBackgrounColor.current.click());
                            }
                          }}
                          style={{ width: 45, height: 45 }}
                        />
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.image')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          name="background_type"
                          ref={refRadioBtnBackgrounImg}
                          onChange={(event) => {
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_type: BACKGROUND_TYPE.IMG,
                            });
                          }}
                          value={1}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        {previewBg && (
                          <img
                            src={previewBg}
                            alt="img"
                            width={IMAGE_SIZES.genre_order_background_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn"
                          hidden
                          name="background_img"
                          onClick={() => {
                            if (refRadioBtnBackgrounImg.current) {
                              refRadioBtnBackgrounImg.current.click();
                            }
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={previewBg && previewBg.length > 0 ? previewBg : ''}
                                  minWidth={IMAGE_SIZES.genre_order_background_img.minWidth}
                                  minHeight={IMAGE_SIZES.genre_order_background_img.minHeight}
                                  maxWidth={IMAGE_SIZES.genre_order_background_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.genre_order_background_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.genre_order_background_img.maxFileSize}
                                  onReflect={(filename: string, imagepath: string) => {
                                    setFieldValue('background_img', filename);
                                    setPreviewBg(imagepath);
                                    setGenrePreview({
                                      ...genrePreview,
                                      background_img: imagepath,
                                    });
                                  }}
                                />
                              ));
                          }}
                        />

                        <label htmlFor="actual-btn" style={{ marginRight: 10 }}>
                          {t('Genre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} rowSpan={7}>
                    {t('Genre.Form.display_name')}
                  </th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.japanese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_ja: event.target.value,
                        });
                      }}
                      name="display_name_ja"
                      placeholder="セレクトランチ"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.english')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_en: values.display_name_en,
                        });
                      }}
                      name="display_name_en"
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.simplified_chinese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hans"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_zh_hans: event.target.value,
                        });
                      }}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.chinese_traditional')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hant"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_zh_hant: event.target.value,
                        });
                      }}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.korean')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_ko: event.target.value,
                        });
                      }}
                      name="display_name_ko"
                      placeholder="셀렉트 점심"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.vietnamese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_vi: event.target.value,
                        });
                      }}
                      name="display_name_vi"
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('Genre.Form.remarks')}
                  </th>
                  <td>
                    <Form.Control as="textarea" onChange={handleChange} name="note" rows={3} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Form>
        );
      }}
    </Formik>
  );
}

export default GenreFormAdd;
